import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";

export const formatDate = (date: string | Date, includeTime?: boolean): string => {
  if (date) {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();

    if (includeTime) {
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
    return `${day}-${month}-${year}`;
  }
  return '--:--:--';
};

export const formatHour = (date: string): string => {
  if (date) {
    const d = new Date(date);
    const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      const seconds = d.getSeconds().toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
  }
  return '--:--:--';
};

export const getStatusName = (type: number) => {
  switch (type) {
    case StatusEnum.INACTIVE:
      return 'Anulado';
    case StatusEnum.ACTIVE:
      return 'Registro activo - En caso de cambios de producto el 1 significa pendiente';
    case StatusEnum.TRIP_CREATED:
      return 'Registro creado';
    case StatusEnum.TRIP_READY_TO_START:
      return 'Registro listo';
    case StatusEnum.TRIP_IN_PROCESS:
      return 'Registro en proceso';
    case StatusEnum.TRIP_CLOSED:
      return 'Registro cerrado';
    case StatusEnum.ORDER_IN_PROGRESS:
      return 'En progreso';
    case StatusEnum.ORDER_APPROVED:
      return 'Aprobado';
    case StatusEnum.ORDER_REJECTED:
      return 'Rechazado';
    default:
      return '-';
  }
};
